import { useFormikContext } from 'formik';

export const useShowValidationErrors = () => {
	const { submitCount } = useFormikContext();

	return submitCount > 0;
};
